import React from 'react';
import { SmartformElementData, ModelTarget } from '../types';
import { modelToPath, objectUtil, useSmartFormContext } from '../forms/utils';

export function withDependentModelValues(
  Component: React.ComponentType<React.PropsWithChildren<SmartformElementData>>,
  models: (ModelTarget | null)[]
): React.FC<SmartformElementData> {
  return (props) => {
    const { values } = useSmartFormContext();
    const dependentValues: (unknown | undefined)[] = [];
    models.forEach((mod) => {
      if (mod) {
        dependentValues.push(objectUtil.getIn(values, modelToPath(mod, false)));
      } else {
        dependentValues.push(undefined);
      }
    });
    return <Component {...props} dependentValues={dependentValues} />;
  };
}
